import Vue from 'vue'
import Router from 'vue-router'

import Home from "../../../components/Home";
import Member from "../../../components/Member";

Vue.use(Router);


const routes = [
    {
        path: "/",
        name: "index",
        component: Home
    },
    {
        path: "/member",
        name: "member",
        component: Member
    }
];

const router = new Router({
    routes: routes,
});


window.router = router;

export default router
